import axios from 'axios';

const api = axios.create({
  baseURL:
    typeof SERVER === 'undefined' || SERVER // eslint-disable-line no-undef
      ? `http://localhost:${typeof PORT === 'undefined' ? '10010' : PORT}` // eslint-disable-line no-undef
      : '/'
});

export default api;
